import React from "react";
import PlayIcon from "../PlayIcon/index.jsx";
import PauseIcon from "../PauseIcon/index.jsx";
import LoadingIcon from "../LoadingIcon/index.jsx";
import PlayerControls from "../PlayerControls/index.jsx";
import { formatTimestamp } from "../formatTimestamp.js";
import { TrackContext } from "../TrackContext.jsx";
import PlayerWave from "../PlayerWave/index.jsx";

const Playbutton = ({ loading, playing, onClick, keyColor }) => {
  if (loading) {
    return (
      <span>
        <LoadingIcon color={keyColor} />
      </span>
    );
  }

  return (
    <button type="button" className="track-play" onClick={onClick}>
      {playing ? <PauseIcon size={24} /> : <PlayIcon size={28} />}
    </button>
  );
};

const Player = ({ track }) => {
  const {
    activeTrackIndex,
    updateActiveTrackIndex,
    trackIds
  } = React.useContext(TrackContext);
  const [pos, setPos] = React.useState(0);
  const [playing, setPlaying] = React.useState(false);
  const [ready, setReady] = React.useState(false);
  const [duration, setDuration] = React.useState("0:00");
  const [currentTime, setCurrentTime] = React.useState("0:00");

  const reset = () => {
    setReady(false);
    setPlaying(false);
  };

  React.useEffect(reset, [track.id]);

  const handlePosChange = currentTime => {
    setPos(currentTime);
    setCurrentTime(formatTimestamp(currentTime));
  };

  const handlePlayClick = () => {
    setPlaying(!playing);
  };

  const handleReady = duration => {
    setDuration(formatTimestamp(duration));
    setReady(true);
  };

  const handlePrevClick = () => {
    const prevTrack = activeTrackIndex - 1 >= 0 ? activeTrackIndex - 1 : 0;
    setPos(0);
    updateActiveTrackIndex(prevTrack);
  };

  const handleNextClick = () => {
    const totalTracks = trackIds.length;
    const nextTrack =
      activeTrackIndex + 1 >= totalTracks
        ? activeTrackIndex
        : activeTrackIndex + 1;
    setPos(0);
    updateActiveTrackIndex(nextTrack);
  };

  return (
    <div className="player-box">
      <div className="player">
        <div className="player__controls">
          <Playbutton
            keyColor={track.keyColor}
            onClick={handlePlayClick}
            loading={!ready}
            playing={playing}
          />
        </div>
        <div className="player__wave">
          <PlayerWave
            audioFile={track.audioSrc}
            pos={pos}
            onPosChange={handlePosChange}
            playing={playing}
            progressColor={track.keyColor || "#E8262D"}
            onReady={handleReady}
          />
        </div>
      </div>
      <div className="player-meta">
        <div className="player-title">{track.title}</div>
        <PlayerControls
          duration={duration}
          currentTime={currentTime}
          pos={pos}
          onPrevClick={handlePrevClick}
          onNextClick={handleNextClick}
        />
      </div>
    </div>
  );
};

export default Player;
